import { supabase } from './db';
import { user } from './store';
export var Providers;
(function (Providers) {
    Providers["slack"] = "slack";
    Providers["discord"] = "discord";
})(Providers || (Providers = {}));
export const getMostRecentLogin = (identities) => {
    if (!identities || !identities.length) {
        return null;
    }
    const mostRecentLogin = identities.slice().sort((a, b) => b.updated_at.localeCompare(a.updated_at))[0];
    return Providers[mostRecentLogin.provider];
};
export const login = async (provider) => {
    try {
        const { error } = await supabase.auth.signIn({
            provider,
        });
        if (error)
            throw error;
    }
    catch (error) {
        console.log(error);
    }
    finally {
        user.set(supabase.auth.user());
    }
};
export const logout = async () => {
    try {
        let { error } = await supabase.auth.signOut();
        if (error)
            throw error;
    }
    catch (error) {
        console.log(error.message);
    }
    finally {
        user.set(null);
    }
};
